import React from 'react';
import { Navbar, Container, Button } from 'react-bootstrap';
import { Logo } from '../Logo';
import LanguageThemeSelector from './LanguageThemeSelector';
import { useLanguage } from '../../context/LanguageContext';
import './PublicHeader.css';

const PublicHeader = () => {
  const { t } = useLanguage();

  const handleGoHome = () => {
    window.location.href = '/';
  };

  return (
    <Navbar 
      className="public-header shadow-sm sticky-top"
      style={{ backgroundColor: 'var(--navbar-bg)' }}
      expand="lg"
    >
      <Container>
        <Navbar.Brand 
          href="#" 
          onClick={(e) => {
            e.preventDefault();
            handleGoHome();
          }}
          className="me-auto"
          style={{ cursor: 'pointer' }}
        >
          <Logo size="medium" />
        </Navbar.Brand>
        
        <Navbar.Toggle aria-controls="public-header-nav" />
        <Navbar.Collapse id="public-header-nav">
          <div className="d-flex align-items-center gap-2 gap-md-3 ms-auto">
            <Button
              variant="outline-primary"
              onClick={handleGoHome}
              className="d-flex align-items-center"
              size="sm"
            >
              <i className="bi bi-house-door d-none d-sm-inline me-2"></i>
              <i className="bi bi-house-door d-sm-none"></i>
              <span className="d-none d-sm-inline">{t('common.home') || 'Home'}</span>
            </Button>
            <LanguageThemeSelector variant="outline-secondary" />
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default PublicHeader;

